import { ReactElement } from 'react'
import { Flex, Box } from '@chakra-ui/react'

import { DecorList } from '@/features/Services/components/atoms/Decorations'
import Section from '@/features/Services/components/organisms/Section'
import DATA_LIST from '@/features/Services/constants'

interface Props {
  id?: string
  data: typeof DATA_LIST[number]
}

function ServiceSection({ id, data }: Props): ReactElement {
  return (
    <Flex
      id={id}
      sx={{
        flexDirection: 'column',
        alignItems: 'stretch',
        w: 'full',
        pt: 10,
        overflowX: 'hidden',
      }}
    >
      {data.POLICY.map((datum, index) => {
        const Decor = DecorList[index]

        return (
          <Box
            key={`${index}`}
            sx={{
              position: 'relative',
            }}
          >
            <Section
              name={data.TITLE}
              primaryColor={data.PRIMARY_COLOR}
              secondaryColor={data.SECONDARY_COLOR}
              policy={datum}
              index={index}
            />
            {Decor && <Decor />}
          </Box>
        )
      })}
    </Flex>
  )
}

export default ServiceSection
